export default __webpack_public_path__ + "static/media/Q20_2_resized.432fc8f7.jpg";